import React, { createContext, useContext, useEffect, useState } from "react";
import { AuthContext } from "./theme/AuthContext";
import { getResumeData } from "./api/resumeapi";

export const ResumeContext = createContext(null);

export const ResumeProvider = ({ children }) => {
  const { user } = useContext(AuthContext); //  user from auth
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  

  useEffect(() => {
    if (!user?.username) return;

    const fetchResume = async () => {
      setLoading(true);
      try {
        const res = await getResumeData(user.username);
       

        setData({
          userId: user.userId,
          ...(res?.Item || {}),
        });
      } catch (err) {
        console.error("Resume fetch failed", err);
      } finally {
        setLoading(false);
      }
    };

    fetchResume();
  }, [user?.username]);

  return (
    <ResumeContext.Provider value={{ data, setData, loading }}>
      {children}
    </ResumeContext.Provider>
  );
};
